import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'smart-inter-stats-view',
  templateUrl: './inter-stats-view.component.html',
  styleUrls: ['./inter-stats-view.component.scss']
})
export class InterStatsViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
